import React from 'react'
import CharterImg from '../Components/assets/images/5.jpg'
import { BookingContent } from '../Components/BookingComponents/BookingContent'

function BookingHome() {
    return (
        <div>
            <div className="container">
                <h2 className='calender-heading'>Book Your Adventure</h2>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="bookingImg-home">
                            <img src={CharterImg} alt="Charter" />
                        </div>
                    </div>
                    <div className="col-lg-6"><BookingContent /></div>
                </div>
            </div>
        </div>
    )
}

export default BookingHome
